module.exports = __webpack_public_path__ + "img/Splash_Shadowbox_Right.44ec7e3e.jpg";